import { render, staticRenderFns } from "./BlogPostsLatest.vue?vue&type=template&id=62b0374d&scoped=true"
import script from "./BlogPostsLatest.vue?vue&type=script&lang=ts"
export * from "./BlogPostsLatest.vue?vue&type=script&lang=ts"
import style0 from "./BlogPostsLatest.vue?vue&type=style&index=0&id=62b0374d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b0374d",
  null
  
)

export default component.exports